<template>
  <v-layout column fill-height>
    <notify-popup-employer v-if="user" />
    <overlay v-if="overlay" />

    <audio src="" style="display: none" autoplay id="audio"></audio>
    <!--<audio src="https://bigsoundbank.com/UPLOAD/mp3/0452.mp3" style="display: none;" id="ringsound"></audio>-->
    <audio ref="ringsound" src="/static/sound/notification.mp3" style="display: none" id="ringsound"></audio>
    <sidebar v-if="sidebar" :mini="mini" :items="items" @changeSidebarState="switchSidebar" />

    <v-toolbar v-if="toolbar" id="toolbar" app fixed left class="pl-toolbar">
      <v-btn
        class="v-toolbar__side-icon v-btn v-btn--icon theme--light grey lighten-4"
        @click.stop="switchSidebar"
        :disabled="load"
      >
        <v-icon v-if="mini">chevron_right</v-icon>
        <v-icon v-else>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title> {{ title }} </v-toolbar-title>

      <v-layout justify-end class="pl-header-menu">
        <v-menu attach="#fooAnchor3" class="finance-operation" bottom offset-y>
          <div
            style="padding-top: 6px"
            id="fooAnchor3"
            class="pl-flex--padding-left15 pl-header-menu__sub-open-btn noselect"
            light
            slot="activator"
            flat
          >
            <v-icon class="ml-2 mr-1">help_outline</v-icon>
            <v-icon class="pl-header__open-icon ml-2">keyboard_arrow_down</v-icon>
          </div>

          <v-list class="pl-arrow-list">
            <template v-for="(item, index) in helpTopMenu">
              <v-divider class="pl-arrow-list__divider" v-if="index != 0" :key="`divider-${index}`" />
              <arrow-item :name="item.name" :title="item.name" @click="onClickMenuHelper(item)" />
            </template>
          </v-list>
        </v-menu>

        <v-divider vertical></v-divider>
        <pl-chat></pl-chat>
        <v-divider vertical></v-divider>
        <v-menu
          v-model="showMenu"
          attach="#fooAnchor"
          class="pl-notifications notification-menu"
          :close-on-content-click="false"
        >
          <div class="pl-flex--padding15" slot="activator" id="fooAnchor">
            <v-badge v-if="unreadNotificationsCounter" color="#ff9800" style="left: -10px">
              <template v-slot:badge>
                <span v-if="unreadNotificationsCounter < 99" class="notification_counter">
                  {{ getCounterUnreadNotificationsTop() }}
                </span>
                <span v-else>
                  <v-icon class="infinity" color="#fff">all_inclusive</v-icon>
                </span>
              </template>
            </v-badge>
            <v-icon
              :class="unreadNotificationsCounter ? 'pl-animation-notification mt-3 pt-1' : 'mt-3 pt-1'"
              color="black"
            >
              notifications_none
            </v-icon>
          </div>
          <v-list class="pl-notifications__list">
            <v-layout class="pl-notifications__list-header pt-2 pb-2" row>
              <v-flex xs6 class="amount pl-4"> Оповещения {{ getCounterUnreadNotifications() }} </v-flex>
              <v-flex xs6 class="link-all-notifications pl-5" @click="navigateTo()">
                {{ lookAllNotificationsText }}
              </v-flex>
            </v-layout>
            <v-layout class="scroll-container" ref="scrollContainer" column>
              <InfiniteScroll
                ref="scroller"
                :scroll-target="$refs.scrollContainer"
                :disable="!unreadNotificationMenu || finished"
                @load="loadMore"
              >
                <template v-for="(item, index) in unreadNotificationsForMenu">
                  <v-divider class="pl-arrow-list__divider" v-if="index != 0" :key="`divider-${index}`" />
                  <v-layout align-center @click="openNotificationModal(item)">
                    <v-flex
                      xs9
                      class="content"
                      style="
                        max-width: 500px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        padding-right: 30px;
                      "
                    >
                      <v-btn flat icon>
                        <v-icon>event_available</v-icon>
                      </v-btn>
                      <span>{{ item.data.message }}</span>
                    </v-flex>
                    <v-flex xs3> {{ formatDate(item.created_at) }}</v-flex>
                  </v-layout>
                </template>
              </InfiniteScroll>
            </v-layout>

            <v-layout
              class="pl-notifications__list-footer"
              v-if="unreadNotificationsForMenu.length > 0"
              justify-center
              align-center
              @click="markerAsReadAll()"
            >
              {{ allAsReadText }}
            </v-layout>
          </v-list>
        </v-menu>
        <v-divider vertical></v-divider>
        <v-menu attach="#fooAnchor1" class="finance-operation" bottom offset-y>
          <div
            style="padding-top: 6px"
            id="fooAnchor1"
            class="pl-flex--padding-left15 pl-header-menu__sub-open-btn noselect"
            light
            slot="activator"
            flat
          >
            <span class="mr-1">Смена</span>
            <v-icon class="pl-header__open-icon ml-2">keyboard_arrow_down</v-icon>
          </div>

          <v-list class="pl-arrow-list">
            <template v-for="(item, index) in sessionMenuLocale">
              <div v-if="checkInventory(item)">
                <v-divider class="pl-arrow-list__divider" v-if="index != 0" :key="`divider-${index}`" />

                <arrow-item :name="item.name" :title="item.name" @click="handleAction(item.action, item.color)" />
              </div>
            </template>
          </v-list>
        </v-menu>
        <v-divider vertical></v-divider>
        <v-menu attach="#fooAnchor2" class="badge" v-show="menu" bottom offset-y>
          <div
            class="pl-flex--padding-left15 noselect"
            style="font-size: 16px"
            id="fooAnchor2"
            light
            slot="activator"
            flat
          >
            <v-badge overlap bottom class="pl-header-menu__badge-margin pl-badge" :color="checkBadgeColor">
              <span slot="badge"></span>
              <div class="container-menu-avatar">
                <div class="name_user">{{ fixLengthName }}</div>
                <div class="avatar_user ml-2">
                  <employer-avatar :item="user"></employer-avatar>
                </div>
              </div>
            </v-badge>
            <v-icon class="pl-header__open-icon">keyboard_arrow_down</v-icon>
          </div>

          <v-list class="pl-arrow-list">
            <template v-for="(item, index) in menu">
              <v-divider class="pl-arrow-list__divider" v-if="index != 0" :key="`divider-${index}`" />
              <arrow-item :name="item.name" :title="menuLocale[item.name]" @click="item.onClick($event)" />
            </template>
          </v-list>
        </v-menu>
      </v-layout>
    </v-toolbar>
    <v-content class="pl-wrapper">
      <slot> </slot>
    </v-content>

    <notifications group="hasBottomNavigation" class="pl-notification-bottom-navigation" position="bottom right" />
    <notifications position="bottom right" />
    <v-dialog v-model="isOpenedSettings" content-class="pl__chat_dialog" width="500">
      <employer-sip-statues-modal />
    </v-dialog>

    <main-helper-modal v-model="isOpenHelper" />

    <authentication-modal
      :opened.sync="showAuthentication"
      @closeAuthenticationModal="closeModalAuthentication($event)"
    />

    <add-save-package
      v-if="user"
      :opened.sync="showSavePackageDialog"
      :curentUser="this.user"
      @closeSavePackageDialog="closeDialogSavePackage($event)"
    />

    <add-inventory
      v-if="user"
      :opened.sync="showInventory"
      :curentUser="user"
      @closeInventoryDialog="showInventory = false"
    />

    <notifications-modal
      @markerAsRead="markerAsRead($event)"
      @closeNotificationsDialog="closeDialogNotification($event)"
      :opened.sync="isOpenedNotificationsDialog"
      :content="notificationDialogContent"
    />

    <snackbar-news v-if="user" :ref="'snackbar-news'" />
  </v-layout>
</template>

<script>
import Vue from 'vue'
import { sidebarItems } from '@/assets/js/sidebar'
import { mapGetters, mapMutations } from 'vuex'
import Sidebar from '@/components/Sidebar/Sidebar'
import PLModal from '@/components/Modal/PLModal'
import Overlay from '@/components/Overlay/Overlay'
import ArrowItem from '@/components/ArrowItem/ArrowItem'
import fullName from '@/helpers/full_name'
import store from '@/store'
import ChatLog from '@/components/Chat/ChatLog.vue'
import ChatComposer from '@/components/Chat/ChatComposer.vue'
import ChatLayout from '@/components/Chat/ChatLayout.vue'
import Counter from '@/components/Counter/Counter.vue'
import EmployerSipStatusesModal from '@/components/Modal/EmployerSipStatusesModal.vue'
import check_user_status from '@/mixins/check_user_status'
import permissions_mixin from '@/mixins/permissions_mixin'
import dialogNotificationsInfo from '@/components/DialogNotifications/DialogNotificationsInfo'
import Authentication from '@/components/App/Dialogs/Authentication'
import AddSavePackage from '@/components/App/Dialogs/AddSavePackage'
import AddInventory from '@/components/App/Dialogs/AddInventory'
import router from '@/router'
import moment from 'moment'
import EmployerAvatar from '@/components/EmployerAvatar/EmployerAvatar'
import snack from '@/helpers/snack'
import PlChat from '@/components/PlChat/PlChat'
import InfiniteScroll from '@/components/InfiniteScroll/InfiniteScroll'
import SnackbarNews from '@/components/SnackbarNews/SnackbarNews'
import MainHelperModal from '@/components/Modal/MainHelperModal'
import NotifyPopupEmployer from '@/components/NotifyPopupEmployer/NotifyPopupEmployer'
const MAX_NAME_LENGTH = 34

export default {
  name: 'Main',
  props: {
    source: String,
  },
  mixins: [check_user_status, permissions_mixin],
  components: {
    sidebar: Sidebar,
    overlay: Overlay,
    'arrow-item': ArrowItem,
    'chat-log': ChatLog,
    'chat-composer': ChatComposer,
    'chat-component': ChatLayout,
    'pl-chat': PlChat,
    'pl-counter': Counter,
    'employer-sip-statues-modal': EmployerSipStatusesModal,
    'notifications-modal': dialogNotificationsInfo,
    'pl-modal': PLModal,
    'authentication-modal': Authentication,
    'add-save-package': AddSavePackage,
    'employer-avatar': EmployerAvatar,
    'snackbar-news': SnackbarNews,
    InfiniteScroll,
    AddInventory,
    MainHelperModal,
    NotifyPopupEmployer: NotifyPopupEmployer,
  },
  computed: {
    ...mapGetters([
      'load',
      'title',
      'menu',
      'sessionMenu',
      'openedSettings',
      'user',
      'userAvatar',
      'userStatus',
      'overlay',
      'snackbar',
      'modalOpen',
      'openedSession',
      'unreadNotifications',
    ]),
    checkSessionColor() {
      return this.colorSession
    },
    fixLengthName() {
      return fullName.by(this.$store.getters.user, MAX_NAME_LENGTH)
    },
    snackbarClasses() {
      return this.snackbar.status ? `pl-snackbar pl-snackbar_${this.snackbar.status}` : 'pl-snackbar'
    },
    isOpenedSettings: {
      get: function () {
        return this.openedSettings
      },
      set: function () {
        store.commit('setOpenedSettings', !this.openedSettings)
      },
    },
    isModalOpen: {
      get: function () {
        return this.modalOpen
      },
      set: function (v) {
        store.commit('setModalOpen', !this.modalOpen)
      },
    },
  },
  data() {
    return {
      showMenu: false,
      pageRender: false,
      drawer: null,
      menuLocale: Vue.config.localization.ru.menu,
      sessionMenuLocale: Vue.config.localization.ru.sessionMenuLocale,
      helpTopMenu: Vue.config.localization.ru.helpTopMenu,
      items: (() => {
        const promise = sidebarItems()
        promise.then(data => {
          return data
        })
      })(),
      snackbarTimeout: Vue.config.snackbar.timeout,
      colorSession: '',
      dialog: false,
      messages: [],
      usersInRoom: [],
      employerData: {},
      sidebar: false,
      toolbar: false,
      isOpenedNotificationsDialog: false,
      notificationDialogContent: {},
      showAuthentication: false,
      showSavePackageDialog: false,
      mini: false,
      allAsReadText: Vue.config.localization.ru.allAsRead,
      lookAllNotificationsText: Vue.config.localization.ru.lookAllNotifications,
      showInventory: false,
      limit: 30,
      offset: 0,
      finished: false,
      unreadNotificationMenu: false,
      unreadNotificationsForMenu: [],
      unreadNotificationsCounter: null,
      isOpenHelper: false,
    }
  },
  methods: {
    ...mapMutations(['setOverlay', 'setModalOpen', 'addNotification']),
    test(val) {
      this.unreadNotificationMenu = val
    },
    externalRout(href) {
      window.open(href, '_blank')
    },
    checkInventory(item) {
      if (item.action === 'inventory') {
        return this.user.unit?.settings?.sendSavePackagesWithoutClose
      } else {
        return true
      }
    },
    async handleAction(action, color) {
      this.colorSession = color
      const sendSavePackages = this.$store.getters.user.unit && this.$store.getters.user.unit.settings.sendSavePackages

      switch (action) {
        case 'open':
          try {
            await store.dispatch('KKM/SESSION_OPEN', {
              user: this.user,
              params: {
                ValueOfFieldString: fullName.by(this.user),
              },
            })
            await this.$axios.post(`${this.$config.server}/${this.$config.modules.crm.api.kkmCashier.sessionOpen}`)
          } catch (e) {
            this.$notify({
              group: 'hasBottomNavigation',
              title: 'Произошла ошибка открытия смены',
              type: 'error',
            })
          }
          break
        case 'inventory':
          this.showInventory = true
          break
        case 'close':
          if (sendSavePackages === undefined || sendSavePackages) {
            this.showSavePackageDialog = true
          } else {
            try {
              await this.$store.dispatch('KKM/SESSION_CLOSE', {
                user: this.user,
                params: {
                  ValueOfFieldString: fullName.by(this.user),
                },
              })
              await this.$axios.post(`${this.$config.server}/${this.$config.modules.crm.api.kkmCashier.sessionClosed}`)
            } catch (e) {
              this.$notify({
                group: 'hasBottomNavigation',
                title: this.$config.localization.ru.loadingError,
                type: 'error',
                text: e.response ? `${e.response.status} ${e.response.statusText}` : '',
              })
            }
          }
          break
        case 'authentication':
          this.showAuthentication = true
          break
        case 'reportX':
          this.$store.dispatch('KKM/SEND_X_REPORT', {
            params: {
              ValueOfFieldString: fullName.by(this.user),
            },
          })
          break
      }
    },
    formatDate(date) {
      return date ? moment(date).format(Vue.config.format.prettyDateFull) : null
    },
    activeMenuElementSetter(menu) {
      const $router = this.$router.currentRoute
      menu = _.each(menu, menuItem => {
        const $findSubRoute = _.find(menuItem.children, { name: $router.name })
        if ($findSubRoute !== undefined || _.indexOf(menuItem.subRoutes, $router.name) !== -1) {
          menuItem.model = true
        }
        return menuItem
      })
      return menu
    },
    switchSidebar() {
      this.mini = !this.mini
    },
    addMessage(message) {
      this.messages.push(message)
      store.dispatch('STORE_MESSAGES', { message: message.message })
    },
    openCallModal() {
      store.commit('setModalOpen', true)
    },
    closeCallModal(e) {
      const ESC_KEYKODE = 27
      if (e.keyCode == ESC_KEYKODE) {
        store.commit('setModalOpen', false)
      }
    },
    openNotificationModal(item) {
      this.notificationDialogContent = item
      this.isOpenedNotificationsDialog = true
    },
    markerAsRead(id) {
      store.dispatch('MARK_NOTIFICATION_AS_READ', { notificationID: id }).then(() => {
        for (let i = 0; i < this.unreadNotificationsForMenu.length; i++) {
          if (this.unreadNotificationsForMenu[i].id == id) {
            this.unreadNotificationsForMenu.splice(i, 1)
            this.unreadNotificationsCounter--
          }
        }
      })
    },
    closeDialogNotification() {
      this.isOpenedNotificationsDialog = false
    },
    closeModalAuthentication() {
      this.showAuthentication = false
    },
    closeDialogSavePackage() {
      this.showSavePackageDialog = false
    },
    navigateTo() {
      router.push({ path: '/notifications' })
    },
    markerAsReadAll() {
      store.dispatch('MARK_ALL_NOTIFICATIONS_AS_READ').then(() => {
        this.unreadNotificationsForMenu.splice(0, this.unreadNotificationsForMenu.length)
        this.unreadNotificationsCounter = 0
      })
    },
    loadMore(i, done) {
      const data = {
        limit: this.limit,
        offset: this.offset,
      }

      store
        .dispatch('GET_UNREAD_NOTIFICATIONS', data)
        .then(res => {
          this.unreadNotificationsForMenu = this.unreadNotificationsForMenu.concat(res)

          this.offset += this.limit
          if (res.length < this.limit) this.finished = true
        })

        .finally(done)
    },
    getCounterUnreadNotifications() {
      if (this.unreadNotificationsCounter === 0) return ''
      else if (this.unreadNotificationsCounter && this.unreadNotificationsCounter < 99)
        return `(${this.unreadNotificationsCounter})`
      return '∞'
    },
    getCounterUnreadNotificationsTop() {
      if (this.unreadNotificationsCounter === 0) return ''
      else if (this.unreadNotificationsCounter && this.unreadNotificationsCounter < 99)
        return this.unreadNotificationsCounter
    },
    onClickMenuHelper(elementMenu) {
      if (elementMenu.showModal) {
        this.isOpenHelper = true
      } else if (elementMenu.externalRout) {
        this.externalRout(elementMenu.router)
      } else {
        this.$router.push({ name: elementMenu.router })
      }
    },
  },
  watch: {
    user(val) {
      this.unreadNotificationsCounter = val.unread_notifications_count
    },
    showMenu(val) {
      this.unreadNotificationMenu = val
    },
    'user.id'(newVal, oldVal) {
      if (oldVal) window.Echo.leave(`Employer.${oldVal}`)

      if (newVal) {
        window.Echo.private(`Employer.${newVal}`).notification(notification => {
          store.commit('addNotification', {
            created_at: new Date(),
            read_at: null,
            data: {
              message: notification.message,
            },
          })
          if (this.finished) {
            const data = {
              created_at: moment(new Date()).format(this.$config.format.serverDateFull),
              id: notification.id,
              type: notification.type,
              data: {
                author: notification.author,
                fix_top: notification.fix_top,
                message: notification.message,
                theme: notification.theme,
              },
            }
            this.unreadNotificationsForMenu.unshift(data)
          }
          this.$refs.ringsound.play()
          this.unreadNotificationsCounter++
          if (notification.type !== this.$config.TYPE_NOTIFICATIONS.NEWS) snack.add(notification.message, 'info')
        })
      }
    },
    unreadNotifications(newVal, oldVal) {
      if (!this.pageRender) {
        this.pageRender = true
        return
      }
    },
    // toolbar(val) {
    //   if (val) {
    // this.loadMore();
    // store.dispatch('GET_UNREAD_NOTIFICATIONS', data).then( res => {
    //   this.offset += this.limit;
    //   this.loading = false;
    //   if (res.length < 30 ) this.loading = true;
    // });
    // }
    // },
    $route(value) {
      const promise = sidebarItems()

      promise.then(data => {
        this.items = this.activeMenuElementSetter(data)
        if (value.name === 'auth' || value.name === 'review') {
          this.sidebar = false
          this.toolbar = false
        } else {
          this.sidebar = true
          this.toolbar = true
        }
      })
    },
  },
  mounted() {
    window.Echo.private(`system`).listen('SystemNotification', e => {
      switch (e.type) {
        case 'notification':
          snack.add(e.message, 'info')
          break

        case 'page_reload':
          setTimeout(() => {
            location.reload()
          }, 3000)
          break
      }
    })
  },
}
</script>

<style scoped>
.infinity {
  position: absolute;
  top: 1px;
  left: 1px;
}
</style>
